<template>
    <rkm-modal
        :buttons="['cancel']"
        @save="$refs.Form.save()"
        extraLarge
        ref="Modal"
        title="Transferência de cota entre unidades"
    >
        <Form
            :data="data"
            :transferenciaLaboratorio="transferenciaLaboratorio"
            :unidadeSolicitanteLaboratorio="unidadeSolicitanteLaboratorio"
            :index="index"
            :item="item"
            :itemCota="itemCota"
            @save="handleExit"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    data: () => ({
        index: null,
        item: null,
        itemCota: null,
    }),
    methods: {
        open(index, item) {

            if (this.unidadeSolicitanteLaboratorio) {

                this.index = index

                let cotasTransferencia = this.data.model.cotasTransferencia.filter(field =>
                    field.laboratorioUnidadeId == this.unidadeId
                    && field.laboratorioInfraestruturaId == this.infraestruturaId
                    && field.origemUnidadeId == item.unidadeSolicitanteId
                    && field.origemInfraestruturaId == item.infraestruturaSolicitanteId
                )

                this.item = cotasTransferencia[0]
                this.itemCota = item

            } else {

                this.index = index
                this.item = item
            }

            this.$refs.Modal.show()
        },
        handleExit(data) {

            this.$emit('save', data)
        },
    },
    props: {
        data: { type: Object, required: true },
        transferenciaLaboratorio: { type: Boolean, default: false },
        unidadeId: { type: Number, default: null },
        infraestruturaId: { type: Number, default: null },
        unidadeSolicitanteLaboratorio: { type: Boolean, default: false },
    }
}
</script>